import { useQuery } from '@tanstack/react-query';
import { countAdminCorrections } from './admin-api';

// The query the register's "awaiting a decision" line reads too, so the badge,
// the hub card and the register agree after a decision invalidates it.
export const ADMIN_CORRECTION_COUNTS_KEY = ['admin-correction-counts'] as const;

/**
 * Caiet §4.2 — the admin's pending correction queue is an attention item.
 * A server-side count (docs/shape-ops-correction-admin-register.md §2 D4): it
 * used to be the length of a 200-row list, wrong past 200.
 */
export function usePendingCorrectionsCount(enabled: boolean): {
  count: number;
  isLoading: boolean;
} {
  const q = useQuery({
    queryKey: ADMIN_CORRECTION_COUNTS_KEY,
    queryFn: countAdminCorrections,
    enabled,
    staleTime: 10_000,
  });
  return { count: q.data?.PENDING ?? 0, isLoading: q.isLoading };
}
